import Vue from 'vue'
import firebase from '@/firebase'
import {parseDocumentsToArray} from '@/utils/populations'


export default {
  namespaced: true,
  state: {
    loading: false,
    error: null,
    items: []
  },
  actions: {
    async initialize ({commit}) {
      console.log('transactions initialize')
      commit('LOADING', true)
      //259200000 = 60 * 60 * 72 * 1000 milliconds in 72h
      const h72 = new Date().getTime() - 259200000
      // firebase.firestore.collection('transactions').where('createdAt', '>', h72).onSnapshot(
      firebase.firestore.collection('transactions').where('state', '==', 'paid').onSnapshot(
        (result) => commit('ON_SNAPSHOT', parseDocumentsToArray(result.docs, 'createdAt', true)),
        (err) => commit('ERROR', err)
      )
    }
  },
  mutations: {
    LOADING (state, loading) {
      Vue.set(state, 'loading', loading)
    },
    ON_SNAPSHOT (state, items = {}) {
      Vue.set(state, 'items', items)
      Vue.set(state, 'loading', false)
    },
    ERROR (state, error) {
      console.error(error)
      Vue.set(state, 'error', error)
      Vue.set(state, 'loading', false)
    }
  }
}


// WEBPACK FOOTER //
// ./src/store/transactions.js